import { createMuiTheme } from '@material-ui/core/styles';
import { deepmerge } from '@material-ui/utils';
import sharedShadows from '../shared/shadows';
import sharedOverrides from '../shared/overrides';
import sharedProps from '../shared/props';
import typography from './typography';
import palette from './palette';
import overrides from './overrides';
var defaultTheme = createMuiTheme();

var productTheme = function productTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$variant = options.variant,
      variant = _options$variant === void 0 ? 'light' : _options$variant;
  var theme = createMuiTheme({
    palette: palette,
    props: sharedProps,
    typography: typography(defaultTheme)
  });
  theme.shadows = sharedShadows(theme.palette.grey[100]);
  theme.overrides = deepmerge(sharedOverrides(theme), overrides({
    theme: theme,
    variant: variant
  }));
  return theme;
};

export default productTheme;